import { apiRequest, apiRequestNormal, requestMethod, ajaxError } from '@/utils/api'
import store from "../index";
// import {Confirm} from 'vue-ydui'
// import { Message } from 'element-ui'
// import {PROMPT} from "../cons";
let apiUrl = 'http://demo.focoon.com.cn';
//let apiUrl = 'https://qa.awpbroker.com';
//let apiUrl = 'https://www.awpbroker.com';

const instance  = {
    state:{

    },
    getters:{
    },
    mutations:{
    },
    actions: {
        // 获取图形验证码
        configRead :function ({commit, state}, obj) {
            return new Promise((resolve, reject) => {
                apiRequest('/customer-restful/restful/customer/verify/graph', 'get', obj)
                    .then(data => {
                        resolve(data)
                    })
                    .catch(err => {
                        reject(err)
                    });
            })
        },
        // 发送邮件
        sendMail :function ({commit, state}, obj) {
            return new Promise((resolve, reject) => {
                apiRequest('/customer-restful/restful/customer/verify/contact', 'post', obj)
                    .then(data => {
                        resolve(data)
                    })
                    .catch(err => {
                        reject(err)
                    });
            })
        },
    }
}

export default instance



// WEBPACK FOOTER //
// ./src/store/module/module_about.js